<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-text="label"
    :items="academicLevels"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    clearable
    :loading="loading"
    :multiple="multiple"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import { AcademicLevel } from '@/plugins/api'

export default {
  data: () => ({
    academicLevels: [],
    loading: false,
  }),
  props: {
    filters: Object,
    defaultGrades: Array,
    options: Object,
    multiple: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters('auth', ['ownGradeIds']),
  },
  created() {
    if (this.defaultGrades) this.academicLevels = this.defaultGrades
    this.fetchAllAcademicLevels()
  },
  methods: {
    async fetchAllAcademicLevels(query) {
      this.loading = true
      const params = {
        ...this.filters,
        ...query,
        // _sort: 'gradeNumber:ASC',
        // _limit: -1,
      }
      if (this.ownGradeIds) params['id_in'] = this.ownGradeIds
      this.academicLevels = await AcademicLevel.fetch(params)
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filters(newVale) {
      if (newVale) this.fetchAllAcademicLevels(newVale)
    },
  },
}
</script>

<style scoped></style>
